module.exports = require("@graphistry/falcor-path-utils/lib/hasIntersection");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/hasIntersection"
// module id = 101
// module chunks = 0